module.exports = __webpack_public_path__ + "static/img/mb1.ace1003.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/mb1.png
// module id = gOZX
// module chunks = 25